import { render, staticRenderFns } from "./editBrandKit.vue?vue&type=template&id=3eb1b203"
import script from "./editBrandKit.vue?vue&type=script&lang=js"
export * from "./editBrandKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports